<!-- <script lang="ts">
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import DirectusLink from '../navigation/DirectusLink.svelte';
	import TextWithIcon from './TextWithIcon.svelte';
	interface AccordionItem {
		id?: string;
		title: string;
		text: string;
		links?: any;
		link?: any;
		iconType?: 'arrow' | 'plus';
	}

	export let items: Array<AccordionItem> = [];
	export let name: string = '';
	// export let openItemId: string | null = null;
	let idx = -1;

	// export const openItemById = (id: string) => {
	// 	const itemIdx = items.findIndex((item) => item.id === id);
	// 	if (itemIdx !== -1) {
	// 		openAccordionItem(itemIdx);
	// 	}
	// };

    const openAccordionItem = (i) => {
        if (idx !== -1) {
            try {
                const panel = document
                    .querySelectorAll('.accordion-' + name + ' .item')
                    [idx].querySelector('.text');
                panel.style.maxHeight = 0;

                const linkPanel = document
                    .querySelectorAll('.accordion-' + name + ' .item')
                    [idx].querySelector('.link');
                linkPanel.style.maxHeight = 0;
            } catch (err) {}
        }

        if (i === idx) {
            idx = -1;
        } else {
            idx = i;

            const newPanel = document
                .querySelectorAll('.accordion-' + name + ' .item')
                [i].querySelector('.text');
            newPanel.style.maxHeight = newPanel?.scrollHeight + 'px';

            const newLinkPanel = document
                .querySelectorAll('.accordion-' + name + ' .item')
                [i].querySelector('.link');
            newLinkPanel.style.maxHeight = newLinkPanel?.scrollHeight + 'px';
        }
    };
</script>

<div class="accordion accordion-{name}">
	{#each items as item, i}
		<div class="item" class:open={i === idx}>
			<div class="title" on:click={() => openAccordionItem(i)}>
				<div>{item.title}</div>
				<div class="arrow">
					{#if item.iconType === 'arrow'}
						<GlobalMedia key="icon-accordion" />
					{:else if i === idx}
						<GlobalMedia key="icon-minus" />
					{:else}
						<GlobalMedia key="icon-plus" />
					{/if}
				</div>
			</div>
			{#if item.text}
				<div class="text">
					{@html item.text}
				</div>
			{/if}
			{#if item.links}
				<div class="link">
					{#each item.links as link}
						<DirectusLink {...link.link_id}>
							<TextWithIcon {...link.link_id} color="yellow" />
						</DirectusLink>
					{/each}
				</div>
			{/if}
		</div>
	{/each}
</div>

<style lang="scss">
	.accordion {
		display: flex;
		flex-direction: column;
		width: 100%;
		// max-width: 50rem;

		.item {
			margin-bottom: 16px;

			.title {
				padding: 8px 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;
				gap: v(content-gap);
				@include font(h5);
				@include media(phone) {
					text-wrap: wrap;
				}
			}
			.arrow {
				transition: all 0.3s ease;
				width: 10px;
				height: 10px;
				flex-shrink: 0;
				margin-inline-start: v(content-padding);
				display: flex;
			}

			.text,
			.link {
				// overflow: hidden;
				opacity: 0;
				transition: all 0.3s ease;
				@include font(text);
				max-width: 600px;
				max-height: 0;

				:global(strong) {
					font-weight: 700;
				}

				:global(p) {
					margin-bottom: v(content-padding);
				}

				:global(ul) {
					list-style-type: disc;
					padding-inline-start: 32px;
				}

				:global(li) {
					margin-bottom: v(content-padding-xs);
				}
			}
			.link {
				display: flex;
				flex-direction: column;
				:global(.text-with-icon) {
					@include font(text);
					line-height: 1.5rem;
				}
			}

			&.open {
				.text {
					opacity: 1;
					// max-height: 1000px;
					max-height: 100% !important;
					margin-top: v(content-gap);
					// max-width: 600px;
				}
				.link {
					opacity: 1;
					margin-top: v(content-gap);
					max-height: 800px;
				}

				.arrow {
					transform: rotate(180deg);
				}
			}
		}
	}
</style> -->
<script lang="ts">
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import DirectusLink from '../navigation/DirectusLink.svelte';
	import TextWithIcon from './TextWithIcon.svelte';
	interface AccordionItem {
		title: string;
		text: string;
		links?: any;
		iconType?: 'arrow' | 'plus';
	}

	export let items: Array<AccordionItem> = [];
	export let name: string = '';
	export let openItemId: string | null = null;
	let idx = -1;

	export const openItemById = (id: string) => {
		const itemIdx = items.findIndex((item) => item.id === id);
		if (itemIdx !== -1) {
			openAccordionItem(itemIdx);
		}
	};

	const openAccordionItem = (i) => {
		if (idx !== -1) {
			try {
				const panel = document
					.querySelectorAll('.accordion-' + name + ' .item')
					[idx].querySelector('.text');
				panel.style.maxHeight = 0;

				const linkPanel = document
					.querySelectorAll('.accordion-' + name + ' .item')
					[idx].querySelector('.link');
				linkPanel.style.maxHeight = 0;
			} catch (err) {}
		}

		if (i === idx) {
			idx = -1;
		} else {
			idx = i;

			const newPanel = document
				.querySelectorAll('.accordion-' + name + ' .item')
				[i].querySelector('.text');
			newPanel.style.maxHeight = newPanel?.scrollHeight + 'px';

			const newLinkPanel = document
				.querySelectorAll('.accordion-' + name + ' .item')
				[i].querySelector('.link');
			newLinkPanel.style.maxHeight = newLinkPanel?.scrollHeight + 'px';
		}
	};
</script>

<div class="accordion accordion-{name}">
	{#each items as item, i}
		<div class="item" class:open={i === idx}>
			<div class="title" on:click={() => openAccordionItem(i)}>
				<div>{item.title}</div>
				<div class="arrow">
					{#if item.iconType === 'arrow'}
						<GlobalMedia key="icon-accordion" />
					{:else if i === idx}
						<GlobalMedia key="icon-minus" />
					{:else}
						<GlobalMedia key="icon-plus" />
					{/if}
				</div>
			</div>
			{#if item.text}
				<div class="text">
					{@html item.text}
				</div>
			{/if}
			{#if item.links}
				<div class="link">
					{#each item.links as link}
						<DirectusLink {...link.link_id}>
							<TextWithIcon {...link.link_id} color="yellow" />
						</DirectusLink>
					{/each}
				</div>
			{/if}
		</div>
	{/each}
</div>

<style lang="scss">
	.accordion {
		display: flex;
		flex-direction: column;
		width: 100%;
		// max-width: 50rem;

		.item {
			margin-bottom: 16px;

			.title {
				padding: 8px 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;
				gap: v(content-gap);
				@include font(h5);
				@include media(phone) {
					text-wrap: wrap;
				}
			}
			.arrow {
				transition: all 0.3s ease;
				width: 10px;
				height: 10px;
				flex-shrink: 0;
				margin-inline-start: v(content-padding);
				display: flex;
			}

			.text,
			.link {
				overflow: hidden;
				opacity: 0;
				transition: all 0.3s ease;
				@include font(text);
				max-width: 600px;
				max-height: 0;

				:global(strong) {
					font-weight: 700;
				}

				:global(p) {
					margin-bottom: v(content-padding);
				}

				:global(ul) {
					list-style-type: disc;
					padding-inline-start: 32px;
				}

				:global(li) {
					margin-bottom: v(content-padding-xs);
				}
			}
			.link {
				display: flex;
				flex-direction: column;
				:global(.text-with-icon) {
					@include font(text);
					line-height: 1.5rem;
				}
			}

			&.open {
				.text {
					opacity: 1;
					// max-height: 1000px;
					max-height: 100% !important;
					margin-top: v(content-gap);
					// max-width: 600px;
				}

				.link {
					opacity: 1;
					max-height: 800px;
					margin-top: v(content-gap);
					// max-width: 600px;
				}

				.arrow {
					transform: rotate(180deg);
				}
			}
		}
	}
</style>
